var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 37,
  height: 37,
  viewBox: "0 0 37 37"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.091,
  y1: 0.079,
  x2: 0.88,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0c70f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0f55b1"
})))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2316",
  "data-name": "Rectangle 2316",
  width: 37,
  height: 37,
  rx: 8,
  fill: "url(#linear-gradient)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_4489",
  "data-name": "Group 4489",
  transform: "translate(8.109 7.996)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_51",
  "data-name": "Ellipse 51",
  cx: 9,
  cy: 9,
  r: 9,
  transform: "translate(-0.109 0.004)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_404",
  "data-name": "Path 404",
  d: "M222.39,1247.38l-3.128-3.055",
  transform: "translate(-205.256 -1230.247)",
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 4
}))));
export default __webpack_public_path__ + "static/media/PrToolLogo.0e9ba51c.svg";
export { SvgComponent as ReactComponent };